import getCalendarPickerStore from '../selectors/getCalendarPickerStore';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';

export default function isRenamingItem(
    scenarioId: CalendarPickerScenarioId,
    itemId: string
): boolean {
    if (!itemId) {
        return false;
    }

    return getCalendarPickerStore(scenarioId).renamingItemId === itemId;
}
